import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = { class: "display-4" }
const _hoisted_4 = { class: "lead" }
const _hoisted_5 = { key: 1 }

import { computed, onMounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'

    import { useWorkspaceInvitationQueryV1 } from '@Organizations/Workspaces/queries-vue-composables'
    import { useAcceptWorkspaceInvitationCommandV1, useRejectWorkspaceInvitationCommandV1 } from '@Organizations/Workspaces/commands-vue-composables'

    /* router */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'WorkspaceInvitationPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()
    const token = route.params.token as string

    /* query */

    const {
        modelWorkspaceInvitationQueryV1: model,
        runWorkspaceInvitationQueryV1
    } = useWorkspaceInvitationQueryV1(token)

    /* derived */

    const workspaceInvitationModel = computed(() => model.value)
    const workspaceId = computed(() => workspaceInvitationModel.value?.WorkspaceId)
    const workspaceName = computed(() => workspaceInvitationModel.value?.WorkspaceName)
    const organizationName = computed(() => workspaceInvitationModel.value?.OrganizationName)
    const recipientEmail = computed(() => workspaceInvitationModel.value?.RecipientEmail)

    /* commands */

    const {
        invokeAcceptWorkspaceInvitationCommandV1,
        onSucceedAcceptWorkspaceInvitationCommandV1
    } = useAcceptWorkspaceInvitationCommandV1(workspaceId, recipientEmail)

    const {
        invokeRejectWorkspaceInvitationCommandV1,
        onSucceedRejectWorkspaceInvitationCommandV1
    } = useRejectWorkspaceInvitationCommandV1(workspaceId, recipientEmail)


    /* lifecycle */

    onMounted(() =>
    {
        document.title = `Invitation to workspace ${workspaceName.value ?? ''}`
        runWorkspaceInvitationQueryV1()
    })

    /* success handling */

    onSucceedAcceptWorkspaceInvitationCommandV1(() =>
    {
        router.push('/organizations/users/dashboard')
    })

    onSucceedRejectWorkspaceInvitationCommandV1(() =>
    {
        router.push('/organizations/users/dashboard')
    })

    /* handlers */

    function handleAcceptWorkspaceInvitationCommandV1()
    {
        if (!workspaceId.value || !recipientEmail.value) return
        invokeAcceptWorkspaceInvitationCommandV1();
    }

    function handleRejectWorkspaceInvitationCommandV1()
    {
        if (!workspaceId.value || !recipientEmail.value) return
        invokeRejectWorkspaceInvitationCommandV1();
    }

return (_ctx: any,_cache: any) => {
  return (workspaceInvitationModel.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, "Invitation to workspace " + _toDisplayString(workspaceName.value), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_4, [
            _cache[0] || (_cache[0] = _createTextVNode(" You were invited to workspace ", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString(workspaceName.value), 1 /* TEXT */),
            _cache[1] || (_cache[1] = _createTextVNode(" owned by ", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString(organizationName.value), 1 /* TEXT */),
            _cache[2] || (_cache[2] = _createTextVNode(" in TransparentChoice application ", -1 /* CACHED */))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("button", {
            onClick: handleAcceptWorkspaceInvitationCommandV1,
            class: "btn btn-success text-white mr-2",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", {
              class: "fa fa-check",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Accept invitation ", -1 /* CACHED */)
          ]))]),
          _createElementVNode("button", {
            onClick: handleRejectWorkspaceInvitationCommandV1,
            class: "btn btn-secondary text-white",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", {
              class: "fa fa-ban",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Reject invitation ", -1 /* CACHED */)
          ]))])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("h4", null, "Loading...", -1 /* CACHED */)
      ]))]))
}
}

})